// ON READY
document.addEventListener('facetwp-loaded', function () {
  console.log('log');
  const facetAlphaBtn = document.querySelector('.facet-alpha-member-wrapper');
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('facet-alpha-member-wrapper')) {
      e.target.classList.add('alpha-member-is-focus');
    } else {
      facetAlphaBtn.classList.remove('alpha-member-is-focus');
    }
  });
});
